/* eslint-disable */

import { useState } from 'react'
import { Mail } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from '../ui/dialog'

import { Button } from '../ui/button'

import tick from '../../assets/SVGS/success.gif'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { removeToken } from '../../utils/AuthUtil'
import { useNavigate } from 'react-router-dom'
import PostHogTracker from '../../utils/PostHogTracker'

const KycPopups = () => {
  const { isOpen, onClose, type, data } = useModal()
  const [showLearnMore, setShowLearnMore] = useState(false)
  const { severity, title, message, handleRedirect } = data
  const navigate = useNavigate()
  const isModalOpen = isOpen && type === 'openKycPopup'

  // user_cancelled
  // error
  // auto_approved
  // auto_declined
  // needs_review

  const handleLogout = () => {
    PostHogTracker.logout('KYC Popup')
    PostHogTracker.reset()
    removeToken()
    navigate('/login')
  }

  const handleContinue = () => {
    onClose(), handleRedirect()
  }

  const kycImages = {
    user_cancelled: 'kyc-cancel.svg',
    auto_approved: 'kyc-updated.svg',
    auto_declined: 'kyc-declined.svg',
    failure: 'kyc-error.svg',
    needs_review: 'kyc-updated.svg',
  }

  return (
    <>
      {severity === 'auto_approved' && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center p-5 w-full max-w-[334px] min-h-[348px] rounded-xl'
            style={{
              background:
                severity === 'auto_approved'
                  ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #7EDD65 0%, #368421 100%)'
                  : severity === 'info'
                    ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #DD9365 0%, #843C21 100%)'
                    : 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #6597DD 0%, #213784 100%)',
            }}
          >
            <DialogHeader>
              <img src={tick} alt={severity} className='h-30 w-30 mx-auto' />

              <DialogTitle className='font-DMSans text-center font-semibold text-xl text-white text-wrap leading-7 tracking-[-0.04em]'>
                {data && title}
              </DialogTitle>
              <DialogDescription className='font-DMSans text-center font-normal text-sm text-white text-wrap leading-5'>
                {data && !data?.isKycPhUpdate && message}

                {data?.isKycPhUpdate && (
                  <div className='flex flex-col justify-center items-center space-x-1'>
                    <p>Your login number updated</p>
                    <p className='px-2 py-1 rounded-sm bg-white text-black-400 font-semibold'>
                      {data?.kycPhoneNumber}
                    </p>
                    <p> Use this number for your future login</p>
                  </div>
                )}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className='justify-center flex-row mt-3'>
              <DialogClose
                onClick={() => handleLogout()}
                style={{ background: '#FFFFFF3D' }}
                className='text-white text-sm min-w-[182px] rounded-xl py-3 px-6 font-medium'
              >
                Logout
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {severity === 'nominee_confirmation' && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center p-5 w-full max-w-[350px] min-h-[348px] rounded-xl'
            style={{
              background:
                severity === 'auto_approved'
                  ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #7EDD65 0%, #368421 100%)'
                  : severity === 'info'
                    ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #DD9365 0%, #843C21 100%)'
                    : 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #6597DD 0%, #213784 100%)',
            }}
          >
            <DialogHeader>
              <Mail className='h-12 w-12 mx-auto mb-4 text-white' />

              <DialogTitle className='font-DMSans text-center font-semibold text-xl text-white text-wrap leading-7 tracking-[-0.04em]'>
                {data && title}
              </DialogTitle>
              <DialogDescription className='font-DMSans text-center font-normal text-sm text-white text-wrap leading-5'>
                {data && !data?.isKycPhUpdate && message}

                {data?.isKycPhUpdate && (
                  <div className='flex flex-col justify-center items-center space-x-1'>
                    <p>Your login number updated</p>
                    <p className='px-2 py-1 rounded-sm bg-white text-black-400 font-semibold'>
                      {data?.kycPhoneNumber}
                    </p>
                    <p> Use this number for your future login</p>
                  </div>
                )}

                <div className='mt-4 p-3'>
                  <p className='text-sm text-white text-wrap leading-5 font-medium mb-1'>
                    💡 Quick Tip:
                  </p>
                  <p className='text-sm text-white text-wrap leading-5'>
                    Search for <span className='font-semibold'>"BSE STAR"</span> or <span className='font-semibold'>"nomination authentication"</span> in your inbox.
                  </p>
                </div>
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className='justify-center flex-row mt-3'>
              <DialogClose
                onClick={() => handleLogout()}
                style={{ background: '#FFFFFF3D' }}
                className='text-white text-sm min-w-[182px] rounded-xl py-3 px-6 font-medium'
              >
                Logout
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}


      {severity === 'cvl_kra_pending' && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center p-5 w-full max-w-[334px] min-h-[348px] rounded-xl'
            style={{
              background:
                severity === 'auto_approved'
                  ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #7EDD65 0%, #368421 100%)'
                  : severity === 'info'
                    ? 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #DD9365 0%, #843C21 100%)'
                    : 'radial-gradient(73.76% 91.42% at 23.07% 21.94%, #6597DD 0%, #213784 100%)',
            }}
          >
            <DialogHeader>
              <Mail className='h-12 w-12 mx-auto mb-4 text-white' />

              {showLearnMore ? (
                <>
                  <DialogTitle className='font-DMSans text-center font-semibold text-xl text-white text-wrap leading-7 tracking-[-0.04em]'>
                    Why is this required?
                  </DialogTitle>
                  <DialogDescription className='text-sm text-white text-center text-wrap leading-5'>
                    Your details in the Central KYC Registry (CKYC) database need to be validated or updated. Central KYC Registry is a centralised repository of KYC records. This is a regulatory requirement to ensure your account remains secure, compliant, and fully authenticated. Our team will guide you through the simple offline step to complete this process.
                  </DialogDescription>



                </>
              ) : (
                <>
                  <DialogTitle className='font-DMSans text-center font-semibold text-xl text-white text-wrap leading-7 tracking-[-0.04em]'>
                    {data && title}
                  </DialogTitle>
                  <DialogDescription className='font-DMSans text-center  font-normal text-sm text-white text-wrap leading-5'>



                    {data && !data?.isKycPhUpdate && <p className='text-sm text-white text-wrap leading-5 mt-4'>{message}</p>}

                    {data?.isKycPhUpdate && (
                      <div className='flex flex-col justify-center items-center space-x-1'>
                        <p>Your login number updated</p>
                        <p className='px-2 py-1 rounded-sm bg-white text-black-400 font-semibold'>
                          {data?.kycPhoneNumber}
                        </p>
                        <p> Use this number for your future login</p>
                      </div>
                    )}



                    <p className='text-sm text-white text-wrap leading-5 mt-2'>
                      Your Relationship Manager will contact you shortly to assist you.
                    </p>

                  </DialogDescription>
                </>
              )}
            </DialogHeader>
            <DialogFooter className='justify-between flex-row mt-3 w-full gap-2'>
              <DialogClose
                onClick={() => navigate('/dashboard')}
                style={{ background: '#FFFFFF3D' }}
                className='text-white text-sm rounded-xl py-3 px-6 font-medium flex-1'
              >
                Okay
              </DialogClose>
              <button
                onClick={() => setShowLearnMore((prev) => !prev)}
                style={{ background: '#FFFFFF3D' }}
                className='text-white text-sm rounded-xl py-3 px-6 font-medium flex-1'
              >
                {showLearnMore ? 'Show less' : 'Learn more'}
              </button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {['auto_declined', 'user_cancelled', 'needs_review', 'failure'].includes(severity) && (
        <Dialog open={isModalOpen} onOpenChange={() => onClose()}>
          <DialogContent
            className='flex flex-col justify-center items-center px-8 py-10 w-full max-w-[334px] min-h-[334px] rounded-xl'
            showclose={severity !== 'needs_review' ? true : false}
          >
            <DialogHeader>
              <img
                src={`${env.SVGS}/${kycImages[severity]}`}
                alt='KYC Cancel'
                className='h-12 w-12 mx-auto mb-8'
              />

              <DialogTitle className='font-DMSans text-center font-semibold text-xl text-black-500 text-wrap leading-7 tracking-[-0.04em]'>
                {data && title}
              </DialogTitle>
              <DialogDescription className='font-DMSans text-center font-normal text-sm text-black-400 text-wrap leading-5'>
                {data && message}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className='justify-center flex-row'>
              {severity !== 'needs_review' ? (
                <Button
                  onClick={handleContinue}
                  className='w-[182px] py-3 px-6 rounded-xl mt-4 text-sm font-medium'
                >
                  Retry KYC
                </Button>
              ) : (
                <Button onClick={handleContinue} className='w-[182px] py-3 px-6 rounded-xl mt-4'>
                  Back to home
                </Button>
              )}
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
export default KycPopups
